/**
 * 📡 NAVBATCHI — ⏳ Jarayonlar panelining alohida tabi (2026-10-28; ilgari 💬 Suhbat ichidagi 📡 tugma edi).
 * Backend: services/overseer.js, routes/conductor.js (`/overseer/items`, `/overseer/items/:id/fix|ignore`, `/overseer/briefing`).
 * «🧠 Agentdan so'rash» — savolni 🧠 Agent tabining yozuv maydoniga qo'yadi (onAsk).
 * 🛠 «Khorezmai kamchiliklari» (2026-10-31, backend services/platformIssues.js, docs/knowledge/200): loyiha agentlari
 * platforma yoki o'zi haqida yozgan kamchilik/takliflar — Claude Code tekshirib tuzatadi, tuzatilgach agentga xabar boradi.
 * Faqat operator/admin (403 bo'lsa bo'lim ko'rinmaydi); loyiha chipidan qat'i nazar hammasi (bular platformaniki).
 * projectId — sarlavhadagi «📁 Faqat <loyiha>» chipi (sukut bo'yicha yoqiq, 2026-10-30): ro'yxat, tab badge'i va
 * «☀️ Hisobotni hozir olish» faqat shu loyiha bo'yicha; null = barcha loyihalar. Chipning o'zi (filterChip) ☀️ tugma
 * yonida — panel sarlavhasi tor oynada to'lib qolgan.
 * ✔ Hal bo'lganlar (tuzatildi / rad etildi) sukut bo'yicha YIG'IQ — ochiqlari tepada, ostida bitta «▸ ✔ Hal bo'lganlar — N ta»
 * (operator, 2026-11-03: «tuzatilganlari yopiq tursin, kerak bo'lsa ochiladi»); «barchasi» belgilansa o'zi ochiladi.
 */
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-hot-toast';

const PI_STATUS = {
  new: { t: 'yangi', c: 'bg-amber-100 dark:bg-amber-900/50 text-amber-800 dark:text-amber-300' },
  claude: { t: "Claude'da", c: 'bg-sky-100 dark:bg-sky-900/50 text-sky-800 dark:text-sky-300' },
  fixed: { t: '✔ tuzatildi', c: 'bg-emerald-100 dark:bg-emerald-900/50 text-emerald-800 dark:text-emerald-300' },
  rejected: { t: 'rad etildi', c: 'bg-gray-200 dark:bg-gray-600 text-gray-600 dark:text-gray-300' },
};

function PlatformIssues({ afRef, apiUrl, active, onNew }) {
  const [data, setData] = useState(null);        // { items, newCount } | null
  const [hidden, setHidden] = useState(false);   // operator emas — bo'lim yo'q
  const [all, setAll] = useState(false);
  const [open, setOpen] = useState(true);
  const [doneOpen, setDoneOpen] = useState(false);
  const [busy, setBusy] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadedAt, setLoadedAt] = useState(null);
  const newRef = useRef(onNew); newRef.current = onNew;
  const allRef = useRef(all); allRef.current = all;

  // Har doim hammasi olinadi: ochiqlari + oxirgi 48 soatda hal bo'lganlari ko'rinadi (2026-10-31, operator: «Claude tuzatgach holatini
  // sahifani qayta yuklamaguncha bilolmadim» — ochiq ro'yxatdan tushib, blok butunlay yashirinardi).
  const load = async (manual = false) => {
    if (manual) setLoading(true);
    try {
      const r = await afRef.current(`${apiUrl}/platform-issues?status=all`);
      if (r.status === 403) { setHidden(true); if (newRef.current) newRef.current(0); return; }
      if (!r.ok) return;
      const d = await r.json();
      setData(d);
      setLoadedAt(new Date());
      if (newRef.current) newRef.current(Number(d.newCount) || 0);
    } catch (e) { } finally { if (manual) setLoading(false); }
  };
  useEffect(() => {
    load();
    const t = setInterval(() => { if (document.visibilityState !== 'hidden') load(); }, active ? 15_000 : 60_000);
    return () => clearInterval(t);
  }, [active]); // eslint-disable-line react-hooks/exhaustive-deps

  const copyPrompt = async (id) => {
    setBusy(id);
    try {
      const r = await afRef.current(`${apiUrl}/platform-issues/${id}/prompt`);
      const d = await r.json().catch(() => ({}));
      if (!r.ok) { toast.error(d.error || 'Olinmadi'); return; }
      try { await navigator.clipboard.writeText(d.text || ''); toast.success("Nusxa olindi — Claude Code'ga tashlang"); }
      catch (e) { window.prompt('Nusxa oling:', d.text || ''); }
    } catch (e) { toast.error("Ulanib bo'lmadi"); } finally { setBusy(null); }
  };
  const act = async (id, action) => {
    let note = null;
    if (action === 'reject') { note = window.prompt("Nega rad etiladi? (sabab agentga boradi)", ''); if (note === null) return; }
    setBusy(id);
    try {
      const r = await afRef.current(`${apiUrl}/platform-issues/${id}/${action}`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note }) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) toast.error(d.error || "Bajarib bo'lmadi"); else toast.success(action === 'reject' ? "Rad etildi — agentga sababi yozildi" : 'Qayta ochildi');
      await load();
    } catch (e) { toast.error("Ulanib bo'lmadi"); } finally { setBusy(null); }
  };

  if (hidden || !data) return null;
  const RECENT_MS = 48 * 3600_000;
  const isOpen = (i) => i.status === 'new' || i.status === 'claude';
  const recent = (i) => !!i.resolved_at && Date.now() - new Date(i.resolved_at).getTime() < RECENT_MS;
  const items = (data.items || []).filter(i => all || isOpen(i) || recent(i));
  if (!items.length && !all) return null;
  const openItems = items.filter(isOpen);
  const doneItems = items.filter(i => !isOpen(i));
  const hm = (d) => { try { return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}:${String(d.getSeconds()).padStart(2, '0')}`; } catch (e) { return ''; } };
  const card = (i) => {
    const st = PI_STATUS[i.status] || PI_STATUS.new;
    const openSt = i.status === 'new' || i.status === 'claude';
    return (
      <div key={i.id} className={`mt-2 rounded-md border bg-white dark:bg-gray-800 p-2 ${openSt ? 'border-gray-200 dark:border-gray-700' : recent(i) ? (i.status === 'fixed' ? 'border-emerald-300 dark:border-emerald-700' : 'border-gray-300 dark:border-gray-600') : 'border-gray-200 dark:border-gray-700 opacity-70'}`}>
        <div className="flex items-center gap-1.5 flex-wrap text-[10px]">
          <span className="font-mono font-semibold text-gray-500 dark:text-gray-400" translate="no">🛠 #{i.id}</span>
          <span className="px-1.5 py-0.5 rounded bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300">{i.kind === 'idea' ? '💡 taklif' : '🐞 kamchilik'}</span>
          <span className="px-1.5 py-0.5 rounded bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300" title={i.about === 'agent' ? "Agentning o'z qoidasi, vositasi yoki xotirasi — agentning o'zi tuzatiladi" : 'Khorezmai platformasi kodi'}>{i.about === 'agent' ? "🤖 agentning o'zi" : '🧩 platforma'}</span>
          <span className={`px-1.5 py-0.5 rounded font-semibold ${st.c}`}>{st.t}{i.status === 'fixed' && i.fixed_version ? ` · ${i.fixed_version}` : ''}</span>
          {!openSt && i.resolved_at && <span className="text-gray-400">{(() => { const m = Math.max(0, Math.round((Date.now() - new Date(i.resolved_at).getTime()) / 60000)); return m < 60 ? `${m} daq oldin` : m < 1440 ? `${Math.floor(m / 60)} soat oldin` : String(i.resolved_at).slice(0, 10); })()}</span>}
          {i.occurrences > 1 && <span className="text-gray-400">×{i.occurrences}</span>}
        </div>
        <div className="font-medium text-gray-900 dark:text-gray-100 text-[13px] mt-1 break-words">{i.title}</div>
        {i.detail && (
          <details className="mt-0.5">
            <summary className="text-[11px] text-gray-500 dark:text-gray-400 cursor-pointer">Tafsilot</summary>
            <div className="text-[12px] text-gray-600 dark:text-gray-300 mt-1"><Rich text={i.detail} />{i.evidence && <div className="mt-1 text-gray-500 dark:text-gray-400"><b>Dalil:</b> <Rich text={i.evidence} /></div>}</div>
          </details>
        )}
        {i.note && <div className="text-[11px] text-emerald-700 dark:text-emerald-400 mt-0.5 whitespace-pre-wrap">{i.note}</div>}
        <div className="text-[10px] text-gray-400 mt-0.5"><span translate="no">{i.project_name || '—'}</span>{i.reporter ? ` · ${i.reporter}` : ''}{i.created_at ? ` · ${String(i.created_at).slice(0, 10)}` : ''}</div>
        <div className="flex gap-1.5 mt-1.5 flex-wrap">
          {openSt && <button type="button" disabled={busy === i.id} onClick={() => copyPrompt(i.id)}
            title="Tekshirish va tuzatish uchun tayyor matn — Claude Code sessiyasiga tashlang (yoki Claude'ga «Navbatchidagi kamchiliklarni ko'r» deng)"
            className="text-xs px-2 py-1 rounded-md bg-violet-600 hover:bg-violet-700 text-white disabled:opacity-50">📋 Claude uchun nusxa</button>}
          {openSt && <button type="button" disabled={busy === i.id} onClick={() => act(i.id, 'reject')} className="text-xs px-2 py-1 rounded-md text-gray-400 hover:text-gray-600">⏭ Rad etish</button>}
          {!openSt && <button type="button" disabled={busy === i.id} onClick={() => act(i.id, 'reopen')} className="text-xs px-2 py-1 rounded-md text-gray-400 hover:text-gray-600">↩ Qayta ochish</button>}
        </div>
      </div>
    );
  };
  return (
    <div className="rounded-lg border border-violet-300 dark:border-violet-700 bg-violet-50/60 dark:bg-violet-900/10 p-2.5">
      <div className="flex items-center justify-between gap-2">
        <button type="button" onClick={() => setOpen(!open)} className="text-left font-semibold text-[13px] text-violet-900 dark:text-violet-200">
          {open ? '▾' : '▸'} 🛠 Khorezmai kamchiliklari{data.newCount ? ` · ${data.newCount} yangi` : ''}
        </button>
        <div className="flex items-center gap-2 shrink-0">
          <button type="button" onClick={() => load(true)} disabled={loading}
            title={`Holatni hozir yangilash (o'zi ham ${active ? 15 : 60} soniyada bir yangilanadi)${loadedAt ? ` · oxirgisi ${hm(loadedAt)}` : ''}`}
            className="text-[12px] px-1.5 py-0.5 rounded text-violet-700 dark:text-violet-300 hover:bg-violet-100 dark:hover:bg-violet-900/40 disabled:opacity-50">
            <span className={loading ? 'inline-block animate-spin' : ''}>↻</span>{loadedAt ? <span className="ml-1 text-[10px] text-gray-400">{hm(loadedAt)}</span> : null}
          </button>
          <label className="text-[11px] text-gray-500 dark:text-gray-400 flex items-center gap-1">
            <input type="checkbox" checked={all} onChange={e => { setAll(e.target.checked); if (e.target.checked) setDoneOpen(true); }} /> barchasi
          </label>
        </div>
      </div>
      {open && (
        <>
          <p className="text-[11px] text-gray-500 dark:text-gray-400 mt-0.5">Loyiha agentlari platforma yoki o'zi haqida yozgan kamchilik va takliflar. Claude Code tekshirib tuzatadi, tuzatilgach agentga xabar boradi.</p>
          {!items.length && <div className="text-[12px] text-gray-500 dark:text-gray-400 py-2">Hozircha yozuv yo'q.</div>}
          {openItems.map(card)}
          {items.length > 0 && !openItems.length && <div className="text-[12px] text-gray-500 dark:text-gray-400 py-1.5">✅ Ochiq kamchilik yo'q.</div>}
          {doneItems.length > 0 && (
            <div className="mt-2">
              <button type="button" onClick={() => setDoneOpen(!doneOpen)} data-kh="pi-done-toggle"
                title={doneOpen ? "Hal bo'lganlarni yig'ish" : "Tuzatilgan va rad etilganlarni ko'rish (↩ Qayta ochish shu yerda)"}
                className="w-full text-left text-[12px] px-2 py-1 rounded-md border border-emerald-200 dark:border-emerald-800 bg-white/70 dark:bg-gray-800/60 text-emerald-800 dark:text-emerald-300 hover:bg-emerald-50 dark:hover:bg-emerald-900/20">
                {doneOpen ? '▾' : '▸'} ✔ Hal bo'lganlar — {doneItems.length} ta{all ? '' : ' (oxirgi 48 soat)'}
              </button>
              {doneOpen && doneItems.map(card)}
            </div>
          )}
        </>
      )}
    </div>
  );
}

function Rich({ text }) {
  return (
    <div className="whitespace-pre-wrap break-words">
      {String(text || '').split(/(\*\*[^*\n]+\*\*)/g).map((p, i) => (/^\*\*[^*]+\*\*$/.test(p) ? <b key={i}>{p.slice(2, -2)}</b> : <React.Fragment key={i}>{p}</React.Fragment>))}
    </div>
  );
}

export default function OverseerPanel({ authFetch, apiUrl, active = true, onAsk = null, onCount = null, projectId = null, projectName = null, filterChip = null }) {
  const afRef = useRef(authFetch); afRef.current = authFetch;
  const countRef = useRef(onCount); countRef.current = onCount;
  const pidRef = useRef(projectId); pidRef.current = projectId;
  const [ov, setOv] = useState(null);            // [] | null
  const [busy, setBusy] = useState(null);
  const [brief, setBrief] = useState(null);      // { text, telegram }
  // Tab badge'i = ochiq Navbatchi holatlari + 🛠 yangi Khorezmai kamchiliklari.
  const ovOpenRef = useRef(0), piNewRef = useRef(0);
  const pushCount = () => { if (countRef.current) countRef.current(ovOpenRef.current + piNewRef.current); };

  const load = async () => {
    const pid = pidRef.current;
    try {
      const r = await afRef.current(`${apiUrl}/overseer/items${pid ? `?projectId=${pid}` : ''}`);
      if (!r.ok) return;
      const d = await r.json();
      if (pid !== pidRef.current) return;   // loyiha almashgan — eski javob ro'yxatni bosmasin
      setOv(d);
      ovOpenRef.current = (d || []).filter(i => i.status === 'open').length;
      pushCount();
    } catch (e) { }
  };
  // Loyiha almashsa — eski ro'yxat/hisobot ko'rinmasin (⏳ dan boshlab yuklanadi).
  useEffect(() => { setOv(null); setBrief(null); }, [projectId]);
  // Badge uchun panel yopiq tabda ham 2 daqiqada bir; ochiq tabda 30 s.
  useEffect(() => {
    load();
    const t = setInterval(() => { if (document.visibilityState !== 'hidden') load(); }, active ? 30_000 : 120_000);
    return () => clearInterval(t);
  }, [active, projectId]); // eslint-disable-line react-hooks/exhaustive-deps

  const act = async (id, action) => {
    setBusy(id);
    try {
      const r = await afRef.current(`${apiUrl}/overseer/items/${id}/${action}`, { method: 'POST' });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || d.ok === false) toast.error(d.error || "Bajarib bo'lmadi"); else toast.success(action === 'fix' ? (d.result || 'Tuzatildi') : 'Belgilandi');
      await load();
    } catch (e) { toast.error("Ulanib bo'lmadi"); } finally { setBusy(null); }
  };
  const briefingNow = async () => {
    setBusy('brief');
    const pid = pidRef.current, pname = projectName;
    try {
      const r = await afRef.current(`${apiUrl}/overseer/briefing`, pid
        ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ projectId: pid }) }
        : { method: 'POST' });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d.ok) { toast.error(d.error || d.skipped || 'Hisobot tayyorlanmadi'); return; }
      if (pid !== pidRef.current) return;   // kutayotganda loyiha almashdi
      setBrief({ text: d.text || '', telegram: !!d.telegram, project: pid ? pname : null });
      toast.success(d.telegram ? "Hisobot tayyor — Telegram'ga ham yuborildi" : 'Hisobot tayyor');
    } catch (e) { toast.error("Ulanib bo'lmadi"); } finally { setBusy(null); }
  };

  return (
    <div className="h-full overflow-y-auto px-4 py-3 space-y-2 text-sm">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="shrink-0 font-semibold text-gray-900 dark:text-white">📡 Navbatchi</div>
        <div className="flex items-center gap-1.5 min-w-0 ml-auto">
          {filterChip}
          <button type="button" onClick={briefingNow} disabled={busy === 'brief'}
            title={`Kechagi natijalar, muammolar va bugun sizdan nima kerakligi — hozir. ${projectName ? `Faqat ${projectName} bo'yicha (barcha loyihalar uchun — 📁 chipni o'chiring)` : 'Barcha loyihalar bo\'yicha'}`}
            className="shrink-0 text-xs px-2.5 py-1 rounded-lg bg-amber-500 hover:bg-amber-600 text-white disabled:opacity-50">{busy === 'brief' ? '⏳' : '☀️ Hisobotni hozir olish'}</button>
        </div>
      </div>
      <p className="text-[11px] text-gray-400">Har 10 daqiqada tekshiradi. Xavfsiz ma'lum xatolarni o'zi tuzatadi (uzilgan vazifa, ishlamay qolgan test muhiti); merge, prod va byudjet — faqat siz.</p>
      {brief && (
        <div className="rounded-lg border border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/20 p-3 text-[13px] text-gray-800 dark:text-gray-100">
          <div className="flex items-center justify-between gap-2 mb-1">
            <span className="text-xs font-semibold text-amber-800 dark:text-amber-300">☀️ Hisobot{brief.project ? <> · <span translate="no">{brief.project}</span></> : ''}{brief.telegram ? ' · Telegram\'ga ham yuborildi' : ''}</span>
            <button type="button" onClick={() => setBrief(null)} className="text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 text-xs">✕</button>
          </div>
          <Rich text={brief.text} />
        </div>
      )}
      <PlatformIssues afRef={afRef} apiUrl={apiUrl} active={active} onNew={(n) => { piNewRef.current = n; pushCount(); }} />
      {ov === null && <div className="text-gray-400">⏳</div>}
      {ov && ov.length === 0 && <div className="text-gray-500 dark:text-gray-400 py-4 text-center">{projectName ? <>✅ <span translate="no">{projectName}</span> bo'yicha hozircha muammo yo'q</> : "✅ Hozircha muammo yo'q"}</div>}
      {(ov || []).map(i => {
        const sev = i.status === 'fixed' ? 'border-emerald-300 dark:border-emerald-700 bg-emerald-50 dark:bg-emerald-900/20'
          : i.severity === 'high' ? 'border-red-300 dark:border-red-700 bg-red-50 dark:bg-red-900/20'
            : i.severity === 'warn' ? 'border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/20' : 'border-gray-200 dark:border-gray-700';
        return (
          <div key={i.id} className={`rounded-lg border p-2.5 ${sev}`}>
            <div className="text-[11px] text-gray-500 dark:text-gray-400"><span translate="no">{i.project}</span>{i.status === 'fixed' ? " · 📡 o'zim tuzatdim" : ''}</div>
            <div className="font-medium text-gray-900 dark:text-gray-100 text-[13px]">{i.title}</div>
            {i.detail && <div className="text-[12px] text-gray-600 dark:text-gray-300 mt-0.5">{i.detail}</div>}
            {i.action_result && <div className="text-[12px] text-emerald-700 dark:text-emerald-400 mt-0.5">{i.action_result}</div>}
            {i.suggestion && i.status !== 'fixed' && <div className="text-[12px] text-gray-500 dark:text-gray-400 mt-1">💡 {i.suggestion}</div>}
            {i.status === 'open' && (
              <div className="flex gap-1.5 mt-2">
                {!!i.fixable && <button type="button" disabled={busy === i.id} onClick={() => act(i.id, 'fix')} className="text-xs px-2 py-1 rounded-md bg-emerald-600 hover:bg-emerald-700 text-white disabled:opacity-50">🔧 Tuzat</button>}
                {onAsk && <button type="button" disabled={busy === i.id} onClick={() => onAsk(`Navbatchi holati: «${i.title}»${i.detail ? ` — ${i.detail}` : ''}. Batafsil tekshir, sababini ayt va nima qilishni taklif qil.`)}
                  title="Savolni 🧠 Agent tabiga yozib qo'yadi"
                  className="text-xs px-2 py-1 rounded-md border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200">🧠 Agentdan so'rash</button>}
                <button type="button" disabled={busy === i.id} onClick={() => act(i.id, 'ignore')} className="text-xs px-2 py-1 rounded-md text-gray-400 hover:text-gray-600">🙈 E'tiborsiz</button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
